<template>
  <div class="curriculum">
    <h2>{{ $t("study_sets.curriculum") }}</h2>
    <el-menu :router="true" :default-active="activeEntry" ref="menu" mode="horizontal" class="menu">
      <el-menu-item class="bg-study-set" :index="`/organization/${organizationId}/studysets`">
        <span>{{ $t("study_sets.menu.study_sets") }}</span>
        <span class="tag-content">MY Content</span>
      </el-menu-item>
      <el-menu-item class="bg-read_alound" :index="`/organization/${organizationId}/read-aloud`" v-if="isOrganizationK12">
        <span>{{ $t("study_sets.menu.read_aloud") }}</span>
        <span class="tag-content">MY Content</span>
      </el-menu-item>
      <el-menu-item class="bg-ai_role_play" :index="`/organization/${organizationId}/scenarios`" v-if="isOrganizationK12 && isOrgAvailableForElsaAI">
        <span>{{ $t("study_sets.menu.role_play_scenario") }}</span>
        <span class="tag-content">ELSA Content</span>
      </el-menu-item>
      <el-menu-item class="bg-assignment" :index="`/organization/${organizationId}/assignment-library`">
        <span>{{ $t("study_sets.menu.all_assignments") }}</span>
      </el-menu-item>

      <el-menu-item v-if="isNotProduction && !isOrganizationK12" class="bg-assessment" :index="`/organization/${organizationId}/assessments`">
        <span>Assessments</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { orgsAvailableELSAAI } from "@/constants/elsaAI";

export default {
  data() {
    return {
      isNotProduction: process.env.VUE_APP_SECRET !== 'production'
    };
  },
  props: {
    activeEntry: {
      type: String,
    },
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.currentOrganizationId;
    },
    ...mapGetters("user", ["isElsaAdmin"]),
    ...mapGetters("organization", ["isOrganizationK12"]),
    isOrgAvailableForElsaAI() {
      return orgsAvailableELSAAI.includes(this.organizationId);
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.curriculum {
  margin-bottom: 50px;

  h2 {
    font-family: SF Pro Display, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 48px;
  }

  .el-menu {
    margin-top: 40px;
    border-bottom: unset;

    li {
      width: 266px;
      height: 108px;
      background: #efeff4;
      border-radius: 12px;
      margin-right: 16px;
      padding-top: 10px;
      padding-left: 16px;
      overflow: hidden;
    }

    a,
    span {
      font-family: 'SF Pro Display', sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 23px;
      line-height: 24px;
      color: #8e8e93;
      font-variant: small-caps;
      text-transform: uppercase;
    }

    li.bg-study-set {
      background-image: url("~@/assets/images/studyset-inactive.svg");
      text-align: left;

      &.is-active {
        background-image: url("~@/assets/images/studyset-active.png");
        background-size: cover;
        .tag-content {
          background: #65DBA4;
        }
      }
    }

    li.bg-assignment {
      background-image: url("~@/assets/images/assignment-inactive.svg");
      text-align: left;

      &.is-active {
        background-image: url("~@/assets/images/assignment-active.png");
        background-size: cover;
      }
    }
    li.bg-read_alound {
      background-image: url("~@/assets/images/read-aloud-inactive.svg");
      text-align: left;

      &.is-active {
        background-image: url("~@/assets/images/read-aloud-active.svg");
        background-size: cover;
        .tag-content {
          background: #65DBA4;
        }
      }
    }

    li.bg-assessment {
      background-image: url("~@/assets/images/assignment-inactive.svg");
      text-align: left;

      &.is-active {
        background-image: url("~@/assets/images/assignment-active.png");
        background-size: cover;
      }
    }

    li.bg-ai_role_play {
      background-image: url("~@/assets/images/ai-role-play-inactive.svg");
      text-align: left;
      
      &.is-active {
        background-image: url("~@/assets/images/ai-role-play-active.svg");
        background-color: #0021D0;
        background-size: cover;
        .tag-content {
          background: rgba(255, 255, 255, .2)
        }
      }
    }
    .tag-content {
      padding: 4px 8px;
      background: #EFEFF4;
      border-radius: 4px;
      border-top-left-radius: 0;
      text-transform: uppercase;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.25px;
      bottom: 0px;
      left: 0px;
      position: absolute;
      color: #8E8E93;
    }
  }

  .el-menu-item {
    border-bottom: unset;
    color: #8e8e93;

    .router-link-active,
    &.is-active {
      span {
        color: #ffffff;
      }
    }
  }
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: unset;
}
</style>
